import React, { useState, useEffect } from "react";
import { Form, Input, TextArea, Checkbox, Button } from "semantic-ui-react";
import Select from "react-select";
import axios from "axios";
import { Fetchexecutequery } from "../../../services/process/BRS1/brsService7";
import { CreateData} from '../../../services/process/process_data/process_data';

const row = {
  display: "flex",
  flexDirection: "row",
  gap: "15px",
  marginBottom: "12px",
  alignItems: "center"
};

const ATTACHMENT_TYPE_OPTIONS = [
  { label: "PDF", value: "pdf", mime: "application/pdf" },
  { label: "Excel (.xlsx)", value: "xlsx", mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
  { label: "Excel (.xls)", value: "xls", mime: "application/vnd.ms-excel" },
  { label: "CSV", value: "csv", mime: "text/csv" },
  { label: "Text File", value: "txt", mime: "text/plain" },
  { label: "ZIP Archive", value: "zip", mime: "application/zip" }
];

const getMimeByType = (type) =>
  ATTACHMENT_TYPE_OPTIONS.find(o => o.value === type)?.mime || "";

const providerOpts = [
  { label: "Gmail", value: "gmail" },
  { label: "Outlook", value: "outlook" },
  { label: "Zoho", value: "zoho" },
  { label: "Yahoo", value: "yahoo" },
  { label: "SendGrid", value: "sendgrid" },
  { label: "Amazon SES", value: "ses" },
  { label: "Custom SMTP", value: "custom" }
];

const smtpPresets = {
  gmail: { smtp_host: "smtp.gmail.com", smtp_port: 587, use_tls: true },
  outlook: { smtp_host: "smtp.office365.com", smtp_port: 587, use_tls: true },
  zoho: { smtp_host: "smtp.zoho.com", smtp_port: 587, use_tls: true },
  yahoo: { smtp_host: "smtp.mail.yahoo.com", smtp_port: 587, use_tls: true },
  sendgrid: { smtp_host: "smtp.sendgrid.net", smtp_port: 587, use_tls: true },
  ses: { smtp_host: "email-smtp.us-east-1.amazonaws.com", smtp_port: 587, use_tls: true }
};

const recipientModes = [
  { label: "Static Email List", value: "static" },
  { label: "Consolidate Query", value: "single_mail" },
  { label: "Row-wise Email", value: "row_wise" },
  { label: "Group-wise Email", value: "group_wise" }
];

const operators = [
  { label: "equal", value: "=" },
  { label: "not equal", value: "!=" },
  { label: "Greater Than", value: ">" },
  { label: "Less Than", value: "<" }
];

const EmailRuleConfigScreen = () => {
  const [tenant, setTenant] = useState([]);
  const [group, setGroup] = useState([]);
  const [entity, setEntity] = useState([]);
  const [division, setDivision] = useState([]);
  const [dept, setDept] = useState([]);
  const [process, setProcess] = useState([]);
  const [error, setError] = useState(null);
  const [schemaOptions, setSchemaOptions] = useState([]);
  const [tableOptions, setTableOptions] = useState([]);
  const [columnOptions, setColumnOptions] = useState([]);
  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const handleCreate = () => {

      const formattedDate = getFormattedDate();
      const updatedFormData = {
        ...data,rule_json
      };

console.log(updatedFormData)
    const payload = {
      database: 'process_data',
      table: 'mail_config',
      formData: updatedFormData
    };

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Create response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const [data, setData] = useState({
    tenants_id: null,
    groups_id: null,
    entity_id: null,
    division_id: null,
    department_id: null,
    process: null,
    rule_name: null,
    description: null,

  });

  const [rule_json, setRule] = useState({
    enabled: true,

    mailbox: {
      provider: "",
      from_email: "",
      display_name: "",
      app_password: "",
      smtp_host: "",
      smtp_port: 587,
      use_tls: true,
      send_limit_per_day: 500
    },

    recipients: {
      to: {
        mode: "static",
        static_emails: [""],
        db: { schema: "", table: "", email_column: "", lookup_column: "", filters: [] }
      },
      cc: {
        mode: "static",
        static_emails: [""],
        db: { schema: "", table: "", email_column: "", lookup_column: "", filters: [] }
      },
      bcc: {
        mode: "static",
        static_emails: [""],
        db: { schema: "", table: "", email_column: "", lookup_column: "", filters: [] }
      }
    },

 mail: {
    subject: "",
    body: "",
    send_mode: "smtp",
    error_mode: "stop"
  },

"attachments": {
  "enabled": true,
  "allow_without_attachments": false,
  "max_size_mb": 20,
  "on_missing": "warn",
  "files": [
    {
      "file_path": "",
      "attachment_type": "xlsx",
      "mime_type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  ]
},

  placeholders: [{ key: "", value_source: "" }],
  conditions: [{ field: "", operator: "exists", expected_value: "" }],
  retry: { max_retries: 3, retry_interval_seconds: 20, exponential_backoff: false },
  logging: { success: true, error: true, smtp_response: true, store_payload: false, metadata: [""] }
  });

  const update = (p, v) => {
    setRule(prev => {
      const c = structuredClone(prev),
        k = p.split("."),
        o = k.slice(0, -1).reduce((a, b) => (a[b] = a[b] || {}, a[b]), c);
      o[k.at(-1)] = v;
      return c;
    });
  };

  const handleProviderChange = s => {
    update("mailbox.provider", s.value);
    if (s.value !== "custom") {
      let p = smtpPresets[s.value];
      update("mailbox.smtp_host", p.smtp_host);
      update("mailbox.smtp_port", p.smtp_port);
      update("mailbox.use_tls", p.use_tls);
    } else {
      update("mailbox.smtp_host", "");
      update("mailbox.smtp_port", 587);
      update("mailbox.use_tls", true);
    }
  };

  const fetchOpts = async (q, l, v, setter) => {
    try {
      const c = Fetchexecutequery();
      const r = await axios.post(c[1], { query: q }, c[0]);
      setter(r.data.map(x => ({ label: x[l], value: x[v] })));
    } catch (e) {
      console.error(e);
    }
  };

  // Load dropdowns
  useEffect(() => {
    fetchOpts(
      `select * from user_management_uat.tenants where is_active=1`,
      "name",
      "tenants_id",
      setTenant
    );
  }, []);

  useEffect(() => {
    if (data.tenants_id)
      fetchOpts(
        `select * from user_management_uat.groups where tenants_id=${data.tenants_id}`,
        "name",
        "groups_id",
        setGroup
      );
  }, [data.tenants_id]);

  useEffect(() => {
    if (data.groups_id)
      fetchOpts(
        `select * from user_management_uat.entities where groups_id=${data.groups_id}`,
        "name",
        "entity_id",
        setEntity
      );
  }, [data.groups_id]);

  useEffect(() => {
    if (data.entity_id)
      fetchOpts(
        `select * from user_management_uat.divisions where entity_id in (${data.entity_id})`,
        "name",
        "division_id",
        setDivision
      );
  }, [data.entity_id]);

  useEffect(() => {
    if (data.division_id)
      fetchOpts(
        `select * from user_management_uat.department where division_id in (${data.division_id})`,
        "name",
        "department_id",
        setDept
      );
  }, [data.division_id]);

  useEffect(() => {
    if (data.entity_id)
      fetchOpts(
        `select * from process_data.process where entity_id in (${data.entity_id})`,
        "process_name",
        "primary_id",
        setProcess
      );
  }, [data.entity_id]);

  // ----------------------------------------
  // RECIPIENT BLOCK COMPONENT
  // ----------------------------------------
  const RecipientBlock = ({ label, path }) => {
    const r = path.split(".").reduce((a, b) => a[b], rule_json);
    const upd = (f, v) => update(`${path}.${f}`, v);

    const addEmail = () => upd("static_emails", [...r.static_emails, ""]);
    const updEmail = (i, v) => {
      let a = [...r.static_emails];
      a[i] = v;
      upd("static_emails", a);
    };
    const delEmail = i => {
      let a = [...r.static_emails];
      a.splice(i, 1);
      upd("static_emails", a);
    };

    const addFilter = () =>
      upd("db.filters", [...(r.db.filters || []), { column: "", operator: "equals" }]);

    const updFilter = (i, f, v) => {
      let a = [...r.db.filters];
      a[i][f] = v;
      upd("db.filters", a);
    };

    const delFilter = i => {
      let a = [...r.db.filters];
      a.splice(i, 1);
      upd("db.filters", a);
    };

    return (
      <div style={{ border: "1px solid #ddd", padding: "10px", marginBottom: "15px" }}>
        <h4>{label}</h4>

        {/* MODE */}
        <div style={row}>
          <label style={{ width: 120 }}>Mode</label>
          <Select
            options={recipientModes}
            value={recipientModes.find(o => o.value === r.mode)}
            onChange={s => upd("mode", s.value)}
          />
        </div>

        {/* STATIC */}
        {r.mode === "static" && (
          <>
            {r.static_emails.map((x, i) => (
              <div key={i} style={row}>
                <Input value={x} onChange={e => updEmail(i, e.target.value)} />
                <Button size="tiny" color="red" onClick={() => delEmail(i)}>
                  X
                </Button>
              </div>
            ))}
            <Button size="tiny" onClick={addEmail}>
              + Add Email
            </Button>
          </>
        )}

        {/* DATABASE */}
        {(r.mode === "single_mail" || r.mode === "row_wise" || r.mode === "group_wise") && (
          <>
            <div style={row}>
              <div style={{ display: "flex", flexDirection: "column", width: "45%" }}>
                <label>Schema</label>
                <Select
                  options={schemaOptions || []}
                  placeholder="Select Schema"
                  value={(schemaOptions || []).find(o => o.value === r.db.schema) || null}
                  onChange={s => upd("db.schema", s?.value || "")}
                  isClearable
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", width: "45%" }}>
                <label>Table</label>
                <Select
                  options={tableOptions || []}
                  placeholder="Select Table"
                  value={(tableOptions || []).find(o => o.value === r.db.table) || null}
                  onChange={s => upd("db.table", s?.value || "")}
                  isClearable
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", width: "45%" }}>
                <label>Email Column</label>
                <Select
                  options={columnOptions || []}
                  placeholder="Select Email Column"
                  value={(columnOptions || []).find(o => o.value === r.db.email_column) || null}
                  onChange={s => upd("db.email_column", s?.value || "")}
                  isClearable
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", width: "45%" }}>
                <label>Lookup Column</label>
                <Select
                  options={columnOptions || []}
                  placeholder="Select Lookup Column"
                  value={(columnOptions || []).find(o => o.value === r.db.lookup_column) || null}
                  onChange={s => upd("db.lookup_column", s?.value || "")}
                  isClearable
                />
              </div>
            </div>

            {/* FILTERS */}
            <h5>Filters</h5>
            {(r.db.filters || []).map((f, i) => (
              <div key={i} style={row}>
                <Input
                  placeholder="column"
                  value={f.column}
                  onChange={e => updFilter(i, "column", e.target.value)}
                />
                <Select
                  options={operators}
                  value={operators.find(o => o.value === f.operator)}
                  onChange={s => updFilter(i, "operator", s.value)}
                />
                <Button size="tiny" color="red" onClick={() => delFilter(i)}>
                  X
                </Button>
              </div>
            ))}
            <Button size="tiny" onClick={addFilter}>
              + Add Filter
            </Button>
          </>
        )}
      </div>
    );
  };
const AttachmentConfig = () => {
  const a = rule_json.attachments || {
    enabled: false,
    allow_without_attachments: true,
    max_size_mb: 20,
    on_missing: "warn",
    files: []
  };

  const updateAttachment = (field, value) =>
    update(`attachments.${field}`, value);

  const updateFile = (index, field, value) => {
    const files = [...(a.files || [])];
    files[index][field] = value;

    // Auto-set MIME when type changes
    if (field === "attachment_type") {
      files[index].mime_type = getMimeByType(value);
    }

    update("attachments.files", files);
  };

  const addFile = () => {
    update("attachments.files", [
      ...(a.files || []),
      {
        file_path: "",
        attachment_type: "",
        mime_type: ""
      }
    ]);
  };

  const removeFile = (index) => {
    const files = [...(a.files || [])];
    files.splice(index, 1);
    update("attachments.files", files);
  };

  return (
    <>
      <h3>Attachments</h3>

      {/* GLOBAL SETTINGS */}
      <div style={row}>
        <Checkbox
          label="Enable Attachments"
          checked={a.enabled}
          onChange={(e, d) => updateAttachment("enabled", d.checked)}
        />

        <Checkbox
          label="Allow Without Attachments"
          checked={a.allow_without_attachments}
          onChange={(e, d) =>
            updateAttachment("allow_without_attachments", d.checked)
          }
        />

        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Max Size (MB)</label>
          <Input
            type="number"
            value={a.max_size_mb}
            onChange={(e) =>
              updateAttachment("max_size_mb", Number(e.target.value))
            }
            style={{ width: 120 }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>On Missing File</label>
          <select
            value={a.on_missing}
            onChange={(e) => updateAttachment("on_missing", e.target.value)}
          >
            <option value="stop">Stop</option>
            <option value="skip">Skip</option>
            <option value="warn">Warn & Continue</option>
          </select>
        </div>
      </div>

      {/* FILE CONFIGURATION */}
      {a.enabled &&
        (a.files || []).map((f, i) => (
          <div key={i} style={row}>

            <div style={{ display: "flex", flexDirection: "column", width: "35%" }}>
              <label>File Path</label>
<Input
  placeholder="/data/reports/file_{{date}}.xlsx"
  value={f.file_path}
  onChangeCapture={(e) =>
    updateFile(i, "file_path", e.target.value)
  }
/>

            </div>

            <div style={{ display: "flex", flexDirection: "column", width: "20%" }}>
              <label>Attachment Type</label>
              <Select
                options={ATTACHMENT_TYPE_OPTIONS}
                value={ATTACHMENT_TYPE_OPTIONS.find(
                  o => o.value === f.attachment_type
                )}
                onChange={(s) =>
                  updateFile(i, "attachment_type", s?.value || "")
                }
                placeholder="Select Type"
                isClearable
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", width: "25%" }}>
              <label>MIME Type</label>
              <Input
                value={f.mime_type}
                disabled
                placeholder="Auto-filled"
              />
            </div>

            <Button
              size="tiny"
              color="red"
              style={{ marginTop: 22 }}
              onClick={() => removeFile(i)}
            >
              X
            </Button>
          </div>
        ))}

      {a.enabled && (
        <Button size="tiny" onClick={addFile}>
          + Add Attachment
        </Button>
      )}
    </>
  );
};


  return (
    <div style={{ padding: 20 }}>
      <h2>Email Rule Configuration</h2>

      <Form>

        {/* =========================== */}
        {/*       RULE PARAMETERS       */}
        {/* =========================== */}
        <h3>Rule Parameters</h3>

        <div style={row}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Rule Name</label>
            <Input
              placeholder="Rule Name"
              value={data.rule_name}
              onChange={e =>
    setData(prev => ({
      ...prev,
      rule_name: e.target.value
    }))}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Description</label>
            <Input
              placeholder="Description"
              value={data.description}
              onChange={e =>
    setData(prev => ({
      ...prev,
      description: e.target.value
    }))}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Status</label>
            <Button
              color={rule_json.enabled ? "red" : "green"}
              onClick={() => update("enabled", !rule_json.enabled)}
              style={{ width: 130 }}
            >
              {rule_json.enabled ? "Deactivate" : "Activate"}
            </Button>
          </div>
        </div>

        {/* =========================== */}
        {/*   ORGANIZATION PARAMETERS   */}
        {/* =========================== */}
        <h3>Organization Parameters</h3>

        <div style={row}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Tenant</label>
            <Select
              options={tenant}
              value={tenant.find(o => o.value === data.tenants_id)}
              onChange={s => setData({ ...data, tenants_id: s.value })}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Group</label>
            <Select
              options={group}
              value={group.find(o => o.value === data.groups_id)}
              onChange={s => setData({ ...data, groups_id: s.value })}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Entity</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              options={entity}
              value={entity.find(o => o.value === data.entity_id)}
              onChange={s =>
                setData({
                  ...data,
                  entity_id: s.map(x => x.value).join(",")
                })
              }
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Division</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              options={division}
              value={division.find(o => o.value === data.division_id)}
              onChange={s =>
                setData({
                  ...data,
                  division_id: s.map(x => x.value).join(",")
                })
              }
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Department</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              options={dept}
              value={dept.find(o => o.value === data.department_id)}
              onChange={s =>
                setData({
                  ...data,
                  department_id: s.map(x => x.value).join(",")
                })
              }
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Process</label>
            <Select
              options={process}
              value={
                process.find(o => String(o.value) === String(data.process)) ||
                null
              }
              onChange={selected =>
                setData(prev => ({
                  ...prev,
                  process: selected?.value || ""
                }))
              }
            />
          </div>
        </div>

        <h3>Mailbox</h3>

        <div style={row}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Provider</label>
            <Select
              options={providerOpts}
              value={providerOpts.find(o => o.value === rule_json.mailbox.provider)}
              onChange={handleProviderChange}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>From Email</label>
            <Input
              value={rule_json.mailbox.from_email}
              onChange={e => update("mailbox.from_email", e.target.value)}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Display Name</label>
            <Input
              value={rule_json.mailbox.display_name}
              onChange={e => update("mailbox.display_name", e.target.value)}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>App Password</label>
            <Input
              type="password"
              value={rule_json.mailbox.app_password}
              onChange={e => update("mailbox.app_password", e.target.value)}
            />
          </div>
        </div>

        {rule_json.mailbox.provider &&
          rule_json.mailbox.provider !== "custom" && (
            <div style={row}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>SMTP Host</label>
                <Input disabled value={rule_json.mailbox.smtp_host} />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>Port</label>
                <Input disabled value={rule_json.mailbox.smtp_port} />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>TLS</label>
                <Checkbox disabled checked={rule_json.mailbox.use_tls} />
              </div>
            </div>
          )}

        {rule_json.mailbox.provider === "custom" && (
          <>
            <div style={row}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>SMTP Host</label>
                <Input
                  placeholder="SMTP Host"
                  value={rule_json.mailbox.smtp_host}
                  onChange={e => update("mailbox.smtp_host", e.target.value)}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>SMTP Port</label>
                <Input
                  type="number"
                  placeholder="Port"
                  value={rule_json.mailbox.smtp_port}
                  onChange={e =>
                    update("mailbox.smtp_port", Number(e.target.value))
                  }
                />
              </div>
            </div>

            <div style={row}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>TLS</label>
                <Checkbox
                  checked={rule_json.mailbox.use_tls}
                  onChange={(e, d) => update("mailbox.use_tls", d.checked)}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>Daily Limit</label>
                <Input
                  type="number"
                  placeholder="Daily Limit"
                  value={rule_json.mailbox.send_limit_per_day}
                  onChange={e =>
                    update(
                      "mailbox.send_limit_per_day",
                      Number(e.target.value)
                    )
                  }
                />
              </div>
            </div>
          </>
        )}

        <h3>Recipients</h3>

        <RecipientBlock label="TO" path="recipients.to" />
        <RecipientBlock label="CC" path="recipients.cc" />
        <RecipientBlock label="BCC" path="recipients.bcc" />

        <h3>Mail Content</h3>

        <div style={row}>
          <label>Subject</label>
          <TextArea
            style={{ width: "100%", minHeight: "50px" }}
            value={rule_json.mail.subject}
            onChange={e => update("mail.subject", e.target.value)}
          />

        </div>

        <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
          <label>Body</label>
          <TextArea
            style={{ width: "100%", minHeight: "120px" }}
            value={rule_json.mail.body}
            onChange={e => update("mail.body", e.target.value)}
          />
        </div>


<div style={row}>
  <div style={{ display: "flex", flexDirection: "column" }}>
    <label>Send Mode</label>
    <select
      value={rule_json.mail.send_mode}
      onChange={e => update("mail.send_mode", e.target.value)}
    >
      <option value="smtp">SMTP</option>
      <option value="api">API</option>
      <option value="ses">Amazon SES</option>
      <option value="sendgrid">SendGrid</option>
    </select>
  </div>

  <div style={{ display: "flex", flexDirection: "column" }}>
    <label>Error Handling</label>
    <select
      value={rule_json.mail.error_mode}
      onChange={e => update("mail.error_mode", e.target.value)}
    >
      <option value="stop">Stop on Error</option>
      <option value="skip">Skip & Continue</option>
      <option value="warn">Warn Only</option>
    </select>
  </div>
</div>

<AttachmentConfig />
        <Button
          color="blue"
          onClick={handleCreate}
        >
          Save Rule
        </Button>
      </Form>
    </div>
  );
};

export default EmailRuleConfigScreen;
